import React, { useState, useEffect } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  ScrollView,
  ActivityIndicator,
} from 'react-native';
import AppLoading from 'expo-app-loading';
import { useFonts } from 'expo-font';
import { db } from '../logic/firebase'; // Assicurati che il percorso sia corretto
import { ref, onValue } from 'firebase/database';

const NewsScreen = () => {
  // Caricamento del font personalizzato
  const [fontsLoaded] = useFonts({
    CustomFont: require('./../../assets/font.ttf'),
  });

  // Stato per le news e stato di caricamento
  const [newsList, setNewsList] = useState([]);
  const [isNewsLoading, setNewsLoading] = useState(true);

  useEffect(() => {
    // Riferimento al nodo "NewsData" in Firebase Realtime Database
    const newsRef = ref(db, 'NewsData');

    onValue(
      newsRef,
      (snapshot) => {
        const data = snapshot.val();
        let mappedResults = [];
        if (data) {
          // Converti l'oggetto in un array aggiungendo la chiave come id
          mappedResults = Object.keys(data).map((key) => ({
            id: key,
            title: data[key].title,
            content: data[key].content, // il contenuto è preso dal campo "content"
            updatedAt: data[key].updatedAt,
          }));
          
          // Ordina le notizie in ordine decrescente rispetto a updatedAt
          mappedResults.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
        }
        setNewsList(mappedResults);
        setNewsLoading(false);
      },
      (error) => {
        console.error("Errore durante il fetch delle news da Firebase:", error);
        setNewsLoading(false);
      }
    );
  }, []);

  // Mostra AppLoading finché i font non sono pronti
  if (!fontsLoaded) {
    return <AppLoading />;
  }

  // Se i font sono caricati ma le news sono ancora in caricamento, mostra lo spinner
  if (isNewsLoading) {
    return (
      <SafeAreaView style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#bb86fc" />
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.screenContainer}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>Notizie</Text>
      </View>
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        {newsList.map((news) => (
          <View key={news.id} style={styles.newsCard}>
            <Text style={styles.newsTitle}>{news.title}</Text>
            <Text style={styles.newsSnippet}>{news.content}</Text>
            <Text style={styles.newsDate}>
              {new Date(news.updatedAt).toLocaleString()}
            </Text>
          </View>
        ))}
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  screenContainer: {
    flex: 1,
    backgroundColor: "#121212",
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#121212",
  },
  header: {
    paddingVertical: 20,
    backgroundColor: "#1f1f1f",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#333",
  },
  headerTitle: {
    fontSize: 24,
    fontFamily: "CustomFont",
    fontWeight: "bold",
    color: "#fff",
  },
  scrollContainer: {
    padding: 15,
  },
  newsCard: {
    backgroundColor: "#1e1e1e",
    padding: 15,
    borderRadius: 10,
    marginBottom: 10,
  },
  newsTitle: {
    fontSize: 20,
    fontFamily: "CustomFont",
    color: "#fff",
    marginBottom: 5,
  },
  newsSnippet: {
    fontSize: 14,
    fontFamily: "CustomFont",
    color: "#ccc",
    marginBottom: 5,
  },
  newsDate: {
    fontSize: 12,
    fontFamily: "CustomFont",
    color: "#888",
    textAlign: "right",
  },
});

export default NewsScreen;
